"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NursysTransactionType = void 0;
exports.instanceOfNursysTransactionType = instanceOfNursysTransactionType;
exports.NursysTransactionTypeFromJSON = NursysTransactionTypeFromJSON;
exports.NursysTransactionTypeFromJSONTyped = NursysTransactionTypeFromJSONTyped;
exports.NursysTransactionTypeToJSON = NursysTransactionTypeToJSON;
exports.NursysTransactionTypeToJSONTyped = NursysTransactionTypeToJSONTyped;
/**
 *
 * @export
 */
exports.NursysTransactionType = {
    ManageNurse: 'MANAGE_NURSE',
    NurseReverification: 'NURSE_REVERIFICATION',
    NurseLookup: 'NURSE_LOOKUP',
    NotificationLookup: 'NOTIFICATION_LOOKUP'
};
function instanceOfNursysTransactionType(value) {
    for (const key in exports.NursysTransactionType) {
        if (Object.prototype.hasOwnProperty.call(exports.NursysTransactionType, key)) {
            if (exports.NursysTransactionType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function NursysTransactionTypeFromJSON(json) {
    return NursysTransactionTypeFromJSONTyped(json, false);
}
function NursysTransactionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function NursysTransactionTypeToJSON(value) {
    return value;
}
function NursysTransactionTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=NursysTransactionType.js.map